import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import config from "../../Config";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import StudentRightsCheck from "./StudentRightsCheck";
import sibling from "../../assets/images/icons/sibling.svg";

function ViewSiblings() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(true);
  const [siblings, setSiblings] = useState([]);

  useEffect(() => {
    document.title = "View Siblings - Student Panel";
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Student_ID: parseInt(UserID, 10) || 0,
    };

    const api_config = {
      method: "post",
      url: config.base_url + "Student/GetSiblings",
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code === 1 && response.data.ListofRecords) {
          setSiblings(response.data.ListofRecords);
        } else {
          setSiblings([]);
          if (response.data.status_code === 0 && response.data.status_message) {
            toast.info(response.data.status_message, { position: toast.POSITION.TOP_RIGHT });
          }
        }
        setLoading(false);
      })
      .catch(function () {
        setSiblings([]);
        setLoading(false);
        toast.info("Sibling information is not available at the moment.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, [AccessKey, UserID, MemberType]);

  return (
    <>
      <StudentRightsCheck />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/student-panel/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      View Siblings
                    </li>
                  </ol>
                </nav>
                <div className="page-title">View Siblings</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container body-content">
        <div className="card">
          <div className="card-body">
            {loading ? (
              <div className="text-center py-5">
                <Spinner animation="border" role="status" />
                <p className="mt-2 mb-0 text-muted">Loading siblings...</p>
              </div>
            ) : siblings.length === 0 ? (
              <div className="text-center py-5">
                <img
                  src={sibling}
                  alt="Siblings"
                  className="mb-3"
                  style={{ maxWidth: "80px", opacity: 0.8 }}
                />
                <h6 className="mb-2">No Siblings Found</h6>
                <p className="text-muted mb-0">
                  There are no other students with the same family number (Family No) enrolled in the school, or your family number is not set.
                </p>
                <Link to="/student-panel/dashboard" className="btn btn-primary mt-3">
                  Back to Dashboard
                </Link>
              </div>
            ) : (
              <>
                <p className="text-muted small mb-3">Siblings enrolled in the school (same family number).</p>
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Father Name</th>
                        <th>Father CNIC</th>
                        <th>Registration No</th>
                        <th>Class</th>
                        <th>Section</th>
                      </tr>
                    </thead>
                    <tbody>
                      {siblings.map((s, index) => (
                        <tr key={s.Student_ID || index}>
                          <td>{index + 1}</td>
                          <td>{s.Student_Name || "—"}</td>
                          <td>{s.Father_Name || "—"}</td>
                          <td>{s.Father_CNIC || "—"}</td>
                          <td>{s.Registration_No || "—"}</td>
                          <td>{s.SelectedClass?.Class_Name || "—"}</td>
                          <td>{s.SelectedSection?.Section_Name || "—"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <Link to="/student-panel/dashboard" className="btn btn-outline-secondary mt-2">
                  Back to Dashboard
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewSiblings;
